export const COMPANY_DEALS_STATUS = {
  ACTIVE: 'active',
  LOST: 'lost',
  CLOSED: 'closed',
  PROJECT: 'project',
  WON: 'won'
}

export const COMPANY_PROPOSAL_STATUS = {
  ACTIVE: 'active',
  WON: 'won',
  LOST: 'lost'
}
